import { render, staticRenderFns } from "./ClaimStatusDetails.vue?vue&type=template&id=0fa9fbfa"
import script from "./ClaimStatusDetails.vue?vue&type=script&lang=ts"
export * from "./ClaimStatusDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports